import React, { useState, Context, ReactElement, Component } from "react";

export interface workload_type {
    kind: string;
    items: workload_type_item[];
}

export interface workload_type_item {
    name?: string;
    type?: string;
    totalPod?: string;
    readyPod?: number;
    createTime?: string;
    podNames?: string[];
    unhealthyPodNames?: string[];
}

const WorkloadContext: Context<[workload_type_item[] | undefined, React.Dispatch<React.SetStateAction<workload_type_item[] | undefined>>]> = React.createContext<[workload_type_item[] | undefined, React.Dispatch<React.SetStateAction<workload_type_item[] | undefined>>]>([undefined, (_value: any) => { }]);

const WorkloadProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [workloads, set_workloads]: [workload_type_item[] | undefined, React.Dispatch<React.SetStateAction<workload_type_item[] | undefined>>] = useState();
    return (
        <WorkloadContext.Provider value={[workloads, set_workloads]}>
            {props.children}
        </WorkloadContext.Provider>
    )
}

export { WorkloadContext, WorkloadProvider };

